// src/heading.tsx
import { Slot } from "@radix-ui/react-slot";
import * as React from "react";

// src/utils/spaces.ts
var withMargin = (props) => [
  withSpace(props.m, ["margin"]),
  withSpace(props.mx, ["marginLeft", "marginRight"]),
  withSpace(props.my, ["marginTop", "marginBottom"]),
  withSpace(props.mt, ["marginTop"]),
  withSpace(props.mr, ["marginRight"]),
  withSpace(props.mb, ["marginBottom"]),
  withSpace(props.ml, ["marginLeft"])
].filter((s) => Object.keys(s).length)[0];
var withSpace = (value, properties) => {
  return properties.reduce((styles, property) => {
    if (value) {
      return { ...styles, [property]: `${value}px` };
    }
    return styles;
  }, {});
};

// src/heading.tsx
import { jsx } from "react/jsx-runtime";
var Heading = React.forwardRef(
  ({ as: Tag = "h1", children, style, m, mx, my, mt, mr, mb, ml, ...props }, forwardedRef) => {
    return /* @__PURE__ */ jsx(
      Slot,
      {
        ...props,
        ref: forwardedRef,
        "data-id": "react-email-heading",
        style: { ...withMargin({ m, mx, my, mt, mr, mb, ml }), ...style },
        children: /* @__PURE__ */ jsx(Tag, { children })
      }
    );
  }
);
Heading.displayName = "Heading";
export {
  Heading
};
